/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {useIsAuthenticated} from "./useIsAuthenticated";
import {useEffect} from "react";

export const useLoginEffect = (logic, additionalDependencies = []) => {
    const isAuthenticated = useIsAuthenticated();
    
    useEffect(() => {
        if (isAuthenticated) {
            logic();
        }
    }, [isAuthenticated, ...additionalDependencies]);
}
